import { useState, useMemo } from 'react'

export function usePagination(data = [], itemsPerPage = 10, fillEmptyRows = false) {
  const [currentPage, setCurrentPage] = useState(1)

  // Calcular valores derivados usando useMemo para optimizar rendimiento
  const pagination = useMemo(() => {
    const totalItems = data.length
    const totalPages = Math.ceil(totalItems / itemsPerPage)

    // Calcular índices para el slice
    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage

    // Obtener datos de la página actual
    let paginatedData = data.slice(startIndex, endIndex)

    // Agregar filas vacías si está habilitado
    if (fillEmptyRows && paginatedData.length < itemsPerPage) {
      const emptyRowsCount = itemsPerPage - paginatedData.length
      const emptyRows = Array.from({ length: emptyRowsCount }, (_, index) => ({
        id: `empty-${currentPage}-${index}`,
        isEmpty: true
      }))
      paginatedData = [...paginatedData, ...emptyRows]
    }

    return {
      currentPage,
      totalPages,
      totalItems,
      itemsPerPage,
      paginatedData
    }
  }, [data, currentPage, itemsPerPage, fillEmptyRows])

  // Solo la función esencial que necesitas
  const goToPage = (page) => {
    if (page >= 1 && page <= pagination.totalPages) {
      setCurrentPage(page)
    }
  }

  return {
    ...pagination,
    goToPage,
    setCurrentPage
  }
}
